export default __webpack_public_path__ + "static/media/redux.ecce4525.png";